<template>
  <div class="breadcrumb">
    <div class="link">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb"

};
</script>

<style lang="scss" scoped>
.breadcrumb {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 0.4rem;
  padding-left: 0.63rem;
  height: 1.25rem;
  background: #409eff;
  box-shadow: 0rem 0rem 1rem 0rem rgba(0, 0, 0, 0.2);

}
</style>
